


/*
import asyncValidate from './asyncValidate'
*/
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'

import { loadPcAction} from '../../actions'
import {loadConfirmDataSH as loadAccount } from '../../redux/svractions/shreviewActions'

import {SVRCFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';


///Users/sam_b2/Downloads/tm/svctest/frontend-quiz/app/css/svdreact.css
//import 'style-loader!../../css/svdreact.css'
import {  Link } from "react-router-dom"
import '../../css/svformwerror.css'
const React = require('react')
const _ = require('lodash')
const {connect}  = require("react-redux")

const svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }


const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}

const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  
  
  let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
       
        if(!formData.card){
            errors.card= 'Required'
        }
        if(!formData.cvv){
            errors.cvv= 'Required'
        }
        if(!formData.mmexp){
            errors.mmexp= 'Required'
        }
        if(!formData.yyyyexp){
            errors.yyyyexp= 'Required'
        }
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class ReservationConfirmationCode extends React.Component{
    componentWillMount()	{
        console.log('sv--call action load to gtethe formvalues pdForm')
        console.log(this.props.params)
         //console.log(this.props.params.id)
         let id;
         if(this.props.params){
            id = this.props.params.id
         
         }else{
          console.log('not called by router')
          id = 1;
         }
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    
       //this.getAppDetails(id)
       // this.props.priceAndTexNow(id);
   
			
			
	

	}
  
     getAppDetails(paramQSpaceId){
        // Previou step of wizard has alrady put the state  in Review get from thatfrom props and pas pdData
        console.log('sv** a29 ***container props needs my_data_price_confirmation')
      console.log(this.props)
      console.log('sv** a29e ***container props needs my_data_price_confirmation')
   
        let newFormData= {

            "status":"OK",
            "confirmationNumber":"UU33333",
            "chekinDate":"Apr 4333"
        } 
        this.props.load(newFormData)
        /*
        this.props.load({
             id:paramQSpaceId,
              gene:"mygenetDummy"
         })
         */
         //this.props.loadReviewNow(paramQSpaceId)
 
         //this.props.sojDetailsAndImagesSV("mancreek") 
         /*this.props.getSojournDetails("mancreek") */
        
     }
 
    constructor(props){
        super(props)
        this.getAppDetails = this.getAppDetails.bind(this)
        this.loadGene = this.loadGene.bind(this)
       
    }
 loadGene(e){
        console.log(e)
    }

   
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)
        let tz_all = null
        let o = _.findWhere(tz_all,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }

    
   
    render(){

let tz_all = [{
    name:'EU Time Zone',
    value:'tz_eu'

  },{
    name:'PST Time Eone',
    value:'tz_pst'
  },{

    name:'CST Time Zone',
    value:'tz_cst'
},{
    name:'EST Time Zone',
    value:'tz_est'
  
  }]
        console.log('sv... SVCDnaStepFormBus')

        const { handleSubmit, previousPage,pristine, error,reset, submitting ,sv_price_confirmation, my_data_price_confirmation } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
        //const { initialValues} = this.props
        console.log('sv********sv_price_confirmation START'   )
        console.log('sv********sv_price_my_data_price_confirmation START'   )
       
        console.log(my_data_price_confirmation)
        if(sv_price_confirmation){
            console.log(sv_price_confirmation)
            let newFormData= {

                "status":"OK",
                "confirmationNumber":"UU33333",
                "chekinDate":"Apr 4333"
            } 
            this.props.initialValues.confirmationNumber =sv_price_confirmation.confirmationNumber
           // this.props.load(sv_price_confirmation)
        }else{
            console.log('sv*NULL**' )
        }
        console.log('sv********sv_price_confirmation END' )
        const { id, gene} = this.props
        const me = this 
        //me.gene = gene

        console.log(this.props)

        return (
            <div>
               
            <form  onSubmit={handleSubmit}>
            <div className="rev-row">
             <div className="card card--raised with-shadow">
                 <header>Confirmatiob Code</header>
        <p className="right-sd-content"> <text>  Send Email {sv_price_confirmation.confirmationNumber}</text></p>
        
        <p className="sd-content"><text>Confirmation Number :{sv_price_confirmation.confirmationNumber?sv_price_confirmation.confirmationNumber :'NO ConfirationNum ' } </text></p>
       {/*  
       we can now use reach checkbox and button to send email or change  diesing to have the email sent in previou step thats better
        <div className="form-group">
                     <label htmlFor="confirmationNumber">  Confirmation Number</label>
                    <Field
                            id="confirmationNumber"
                            name="confirmationNumber"
                            type="text"
                            placeholder="123"
                            component={renderField}
                            className="form-control"
                    />
                </div>
        */}
        <div className="form-group">
                     <label htmlFor="needConfirmCodeByEmail"> </label>
                     <Field
                    
                    id="needConfirmCodeByEmail"
                       name="needConfirmCodeByEmail"
                       type="checkbox"
                       placeholder="id"
                       component="input"
                       className="form-control"
                   />
        </div>
        


        </div>

</div>



                

               <div>

              
        {/* 

        <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
           Remove Not needededEmailSentBefefault
        </button>  
        <button type="button" className="btn btn-success" onClick={previousPage}>
          Previous
        </button>
         */}
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svessearch`}> Home  </Link></SVAButton>
           </div>
               

               

            </form>
         </div>
        )
    }

}

const rcForm = reduxForm({

    form:SVRCFORM,
    validate:validate,
    //asyncValidate: asyncValidate,
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(ReservationConfirmationCode)

const selector = formValueSelector(SVRCFORM)




let ReservationConfirmationCodeFormBusCom =connect((state=>{

    let plucked = state.movies
    let o = {initialValues:plucked.rcData }
    selector(state, 'id')
    console.log('sv info')
    console.log(o)
    return o
}),{
    load:loadAccount,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(rcForm)





export default ReservationConfirmationCodeFormBusCom